export default __webpack_public_path__ + "static/media/roboto-condensed-v19-latin-700italic.a4bca9fe.woff2";